var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("filter-buttons", {
        attrs: {
          "selected-filters-count": _vm.visibleSelectedFilters.length,
          "total-item-count": _vm.filters.totalItemCount.value,
          "sort-display-name": _vm.filters.sortDisplayName.value,
          "filters-with-display-names": _vm.filtersWithDisplayNames,
        },
        on: {
          "filters-open": _vm.onFiltersOpen,
          "sort-open": _vm.onSortOpen,
          "filter-delete": _vm.onFilterDelete,
        },
      }),
      _vm._v(" "),
      _vm._t("header", null, {
        filters: _vm.filters,
        onFilterChange: _vm.onFilterChange,
      }),
      _vm._v(" "),
      _c("filter-drawer", {
        attrs: {
          schema: _vm.filterSchema,
          "selected-filters": _vm.selectedFilters,
          "is-drawer-open": _vm.isFilterDrawerOpen,
          title: _vm.filterListTitle,
          "has-clear-button": "",
        },
        on: {
          search: _vm.onApplyFilters,
          clear: _vm.onClearFilters,
          close: _vm.onFiltersClose,
        },
      }),
      _vm._v(" "),
      _c("filter-drawer", {
        attrs: {
          schema: _vm.sortSchema,
          "selected-filters": _vm.selectedFilters,
          "is-drawer-open": _vm.isSortDrawerOpen,
          title: _vm.sortListTitle,
        },
        on: { search: _vm.onApplySort, close: _vm.onSortClose },
      }),
      _vm._v(" "),
      _vm._t("default", null, {
        items: _vm.filters.pagedItems.value,
        isProcessing: _vm.filters.isProcessing.value,
        isLoadingMore: _vm.filters.isLoadingMore.value,
        canLoadMore: _vm.filters.canLoadMoreRows.value,
        loadMore: _vm.filters.loadMoreRows,
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }